import React from "react";

import Login from "../Login/Login";

const LoginPage = () => {
    return <Login />;
};

export default LoginPage;
